import Api from 'api/Api';
import useMeStore from 'store/useMeStore';
import useNotificationStore, {
    NotificationTypes,
} from 'store/useNotificationStore';
import { downloadBlobAsFile } from 'utils/download';

export default function useAssignmentPDF() {
    const token = useMeStore(state => state.token);

    const pushNotification = useNotificationStore(state => state.push);

    const fetchTimesheetPDF = async (
        id: string,
        year?: number | null,
        week?: number | null
    ) => {
        Api.assignment
            .fetchAssignmentReportPDF(token, id)
            .then(function (response) {
                const { status, data } = response;
                if (status === 200) {
                    const href = URL.createObjectURL(data);

                    // create "a" HTML element with href to file & click
                    const link = document.createElement('a');
                    link.href = href;
                    let name = 'tidrapport';
                    if (year && week) {
                        name = `tidrapport_${year}_${week}`;
                    }
                    name += '.pdf';
                    link.setAttribute('download', name); //or any other extension
                    document.body.appendChild(link);
                    link.click();

                    // clean up "a" element & remove ObjectURL
                    document.body.removeChild(link);
                    URL.revokeObjectURL(href);
                } else {
                    throw new Error('Failed fetching pdf');
                }
            })
            .catch(function (err) {
                console.log(err);
                pushNotification(
                    NotificationTypes.error,
                    err?.response?.data?.message ||
                        'Det gick inte att hämta tidrapport, försök igen.',
                    'pdf-fetch-fail',
                    1
                );
            });
    };

    const fetchBookingConfirmationPDF = async (id: string) => {
        try {
            const response =
                await Api.assignment.fetchAssignmentBookingConfirmationPDF(
                    token,
                    id
                );
            const { status, data } = response;
            if (status === 200) {
                downloadBlobAsFile(data, 'bokningsbekräftelse.pdf');
            } else {
                throw new Error('Failed fetching pdf');
            }
        } catch (err: any) {
            console.log(err);
            pushNotification(
                NotificationTypes.error,
                err?.response?.data?.message ||
                    'Det gick inte att hämta bokningsbekräftelse, försök igen.',
                'assignment',
                2
            );
        }
    };

    return {
        fetchTimesheetPDF,
        fetchBookingConfirmationPDF,
    };
}
